import { MenuButtonData, MenuButtonLinkType } from "../system/Classes/MenuButtonData";

export const menuData: Array<MenuButtonData> = [
    { display: "首頁", path: "home", type: MenuButtonLinkType.Navigate },
    { display: "學校簡介", path: "/intro/principal", type: MenuButtonLinkType.Navigate, },
    { display: "教學與發展", path: "test", type: MenuButtonLinkType.SubMenu },
    { display: "計劃/報告", path: "https://www.pkps.edu.hk/pdf/2022-2023/report.pdf", type: MenuButtonLinkType.ReportMenu },
    { display: "入學資訊", path: "/enrollment/features", type: MenuButtonLinkType.Navigate,  },
    { display: "校內圖書館", path: "https://eclass.pkps.edu.hk/home/elibplus/", type: MenuButtonLinkType.WindowOpen },
    /*{ display: "校內圖書館", path: "http://www.pkps.edu.hk/newhtml/lib.html", type: MenuButtonLinkType.WindowOpen },*/
];

export const subjectMenuData: Array<MenuButtonData> = [
    { display: "中文", path: "/courseTarget/ChiObjectives" },
    { display: "英文", path: "/courseTarget/EngObjectives" },
    { display: "數學", path: "/courseTarget/MathsObjectives" },
    { display: "常識", path: "/courseTarget/GsObjectives" },
    { display: "普通話", path: "/courseTarget/PthObjectives" },
    { display: "音樂", path: "/courseTarget/MusicObjectives" },
    { display: "體育", path: "/courseTarget/PeObjectives" },
    { display: "生活及情意教育", path: "/courseTarget/UpIndex" },
    { display: "視藝", path: "/courseTarget/VaObjectives" },
    { display: "資訊科技", path: "/courseTarget/ItObjectives" },
    { display: "學校評估政策", path: "/courseTarget/TxDef" },
    { display: "聯課活動", path: "/courseTarget/CCA" },
]

export const reportMenuData: Array<MenuButtonData> = [
    { display: "校外評估報告", path: "https://www.pkps.edu.hk/pdf/2022-2023/report.pdf", type: MenuButtonLinkType.WindowOpen },
    { display: "校務報告", path: "/Report/school_report", type: MenuButtonLinkType.Navigate },
    { display: "學校發展計劃", path: "https://www.pkps.edu.hk/pdf/2024-2025/report/3/24-27.pdf", type: MenuButtonLinkType.WindowOpen },
    { display: "學校周年計劃", path: "/Report/anniversary_plan", type: MenuButtonLinkType.Navigate },
    { display: "全方位學習及姊妹學校津貼", path: "/Report/all_round", type: MenuButtonLinkType.Navigate },
    { display: "校本課後學習及支援計劃", path: "/Report/support_report", type: MenuButtonLinkType.Navigate },
    { display: "學校發展津貼", path: "/Report/development_subsidy", type: MenuButtonLinkType.Navigate },
    { display: "運用推廣閱讀津貼計劃", path: "/Report/reading_report", type: MenuButtonLinkType.Navigate },
    { display: "學生活動支援津貼", path: "https://www.pkps.edu.hk/pdf/2025-2026/report/9/24-25report.pdf", type: MenuButtonLinkType.WindowOpen },
    { display: "校董周年培訓計劃", path: "https://www.pkps.edu.hk/pdf/report/10/25-26plan.pdf", type: MenuButtonLinkType.WindowOpen },
    { display: "各類一次性津貼計劃", path: "/Report/other_report", type: MenuButtonLinkType.Navigate },
]